import React, { useState } from "react";
import "./CloudWatchEvent.css";
import Badge from "react-bootstrap/Badge";
import ReactJsonView from "react-json-view";
import { getBondColor } from "../../../../../../../../lib/ui/colorUtils.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloud, faLink, faUnlink, faNetworkWired, faUserSlash, faCode } from "@fortawesome/free-solid-svg-icons";

function CloudWatchEvent({ event }) {
    const [showJson, setShowJson] = useState(false);
    const isConnected = event.payload.eventType === 'connected';
    const isDisconnected = event.payload.eventType === 'disconnected';

    const icon = isConnected ? faLink : faUnlink;
    const color = isConnected ? 'success' : 'danger';

    return (
        <div className="d-flex flex-column gap-2 w-100">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2" style={{ minHeight: '48px' }}>
                {/* Left side: Event Type Badge and JSON Toggle */}
                <div className="d-flex gap-2 align-items-center">
                    <Badge bg={color} className="d-flex align-items-center justify-content-center" style={{ fontSize: '1rem', minHeight: '30px', minWidth: '200px', padding: '0.5rem 0.75rem' }}>
                        <FontAwesomeIcon icon={icon} className="me-1" />
                        {event.payload.eventType}
                    </Badge>

                    {/* JSON Viewer Toggle */}
                    <Badge
                        bg={showJson ? "secondary" : "dark"}
                        className="d-flex align-items-center justify-content-center json-toggle-btn"
                        style={{ cursor: 'pointer', fontSize: '0.9rem', padding: '0.4rem 0.6rem', minHeight: '30px' }}
                        onClick={() => setShowJson(!showJson)}
                        title="Toggle JSON view"
                    >
                        {"{"}
                        {"}"}
                    </Badge>
                </div>

                {/* Right side: Event details */}
                <div className="d-flex flex-wrap align-items-center gap-2 ms-auto">
                    {/* CONNECTED EVENT: Show IP Address */}
                    {isConnected && event.payload.ipAddress && (
                        <Badge bg="info" className="d-flex align-items-center" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>
                            <FontAwesomeIcon icon={faNetworkWired} className="me-1" />
                            {event.payload.ipAddress}
                        </Badge>
                    )}

                    {/* DISCONNECTED EVENT: Show disconnect reason and who initiated */}
                    {isDisconnected && (
                        <>
                            {/* Disconnect Reason */}
                            {event.payload.disconnectReason && (
                                <Badge bg="warning" className="text-dark" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>
                                    {event.payload.disconnectReason}
                                </Badge>
                            )}

                            {/* Who initiated the disconnect */}
                            {event.payload.clientInitiatedDisconnect !== undefined && (
                                <Badge bg={event.payload.clientInitiatedDisconnect ? "secondary" : "danger"} style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>
                                    <FontAwesomeIcon
                                        icon={event.payload.clientInitiatedDisconnect ? faUserSlash : faNetworkWired}
                                        className="me-1"
                                    />
                                    {event.payload.clientInitiatedDisconnect ? "Client Initiated" : "Server Initiated"}
                                </Badge>
                            )}
                        </>
                    )}
                </div>
            </div>

            {/* JSON Viewer */}
            {showJson && (
                <div className="mt-2">
                    <ReactJsonView
                        src={event.payload}
                        className="mqttEventPayload"
                        theme="ocean"
                        borderStyle="none"
                        name={false}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        collapsed={false}
                        enableClipboard={true}
                    />
                </div>
            )}
        </div>
    );
}

export default CloudWatchEvent;
